import { Action } from "@ngrx/store";
import { Contract } from "@edp-components/edp-contract";
import { ActiveMeters, IMeterTypes } from "@edp-components/edp-card-widgets/edp-widget-consumptions/edp-consumptions.models";
import { ICampaign } from "@edp-models/edp-campaigns.model";
import { IBankList } from "@edp-models/bank.model";
import { IReading } from "@edp-models/readings.model";
import { ElectricMobilityWidget } from "@edp-models/electric-mobility.model";
import { EdpUser } from "@edp-models/user.model";


export enum EDashboardActions {
    GetInvoices = "Get Invoices",
    SetInvoices = "Set Invoices",
    InvoicesAPIError = "[Dashboard] Invoices API error",
    GetBalance = "Get Balances",
    SetBalance = "Set Balance",
    BalanceAPIError = "[Dashboard] Balance API error",
    GetActiveMeters = "Get ActiveMeters",
    SetActiveMeters = "Set ActiveMeters",
    SetActiveMetersElectricity = "Set ActiveMeters of Electricity",
    SetActiveMetersGas = "Set ActiveMeters of Gas",
    SetContractRequests = "[Dashboard] Set Contract Requests",
    GetContractRequests = "[Dashboard] Get Contract Requests",
    ContractRequestsAPIError = "[Dashboard] Contract Requests API error",
    UploadReading = "Upload Reading",
    SetUploadReading = "Set Upload Reading",
    GetSimulation = "Get Simulation Reading",
    SetSimulation = "Set Simulation Reading",
    GetFunciona = "Get Funciona",
    SetFunciona = "Set Funciona",
    FuncionaAPIError = "[Dashboard] Funciona API error",
    GetCampaigns = "[Campaigns] Get Campaigns Request",
    SetCampaigns = "[Campaigns] Set Campaigns Request",
    CampaignsAPIError = "[Campaigns] Campaigns Request API error",
    RequestAPIError = "[Error] Request API error",
    ClearSelectedContractData = "[Dashboard] Clear Selected Contract Data",
    GetRecaptcha = "Get Recaptcha",
    SetRecaptcha = "Set Recaptcha",
    GetRecaptchaResponse = "Get Recaptcha Response",
    SetRecaptchaResponse = "Set Recaptcha Response",
    GetBankList = "Get Bank List",
    SetBankList = "Set Bank List",
    GetMeterInstructions = "Get Meter Instructions",
    SetMeterInstructions = "Set Meter Instructions",
    MeterInstructionsAPIError = "[MeterInstructions] MeterInstructions Request API error",
    ClearSelectedContractDataInDashboard = "ClearSelectedContractDataInDashboard",
    GetElectricMobilityWidgetData = "[Dashboard] Get Electric Mobility Widget Data",
    SetElectricMobilityWidgetData = "[Dashboard] Set Electric Mobility Widget Data",
    ElectricMobilityWidgetAPIError = "[Dashboard] Electric Mobility Request API error",
    ShowNewLocalToastr = "[Dashboard] Show new local toastr"
}

export class GetInvoices implements Action {
    public readonly type = EDashboardActions.GetInvoices;
    constructor(public contract: Contract) {}
}

export class SetInvoices implements Action {
    public readonly type = EDashboardActions.SetInvoices;
    constructor(public payload) {}
}

export class InvoicesAPIError implements Action {
    public readonly type = EDashboardActions.InvoicesAPIError;
    constructor(public error: Error) {}
}

export class GetBalance implements Action {
    public readonly type = EDashboardActions.GetBalance;
    constructor(public contract: Contract) {}
}

export class BalanceAPIError implements Action {
    public readonly type = EDashboardActions.BalanceAPIError;
    constructor(public error: Error) {}
}

export class SetBalance implements Action {
    public readonly type = EDashboardActions.SetBalance;
    constructor(public payload) {}
}

export class GetActiveMeters implements Action {
    public readonly type = EDashboardActions.GetActiveMeters;
    constructor(public contract: Contract, public supplyType: string = "", public isLocal?: boolean) {}
}

export class SetActiveMetersElectricity implements Action {
    public readonly type = EDashboardActions.SetActiveMetersElectricity;
    constructor(public payload: ActiveMeters[]) {}
}

export class SetActiveMetersGas implements Action {
    public readonly type = EDashboardActions.SetActiveMetersGas;
    constructor(public payload: ActiveMeters[]) {}
}

export class GetContractRequests implements Action {
    public readonly type = EDashboardActions.GetContractRequests;
    constructor(public contract: Contract) {}
}

export class ContractRequestsAPIError implements Action {
    public readonly type = EDashboardActions.ContractRequestsAPIError;
    constructor(public error: Error) {}
}

export class RequestAPIError implements Action {
    public readonly type = EDashboardActions.RequestAPIError;
    constructor(public error: Error) {}
}

export class SetContractRequests implements Action {
    public readonly type = EDashboardActions.SetContractRequests;
    constructor(public payload) {}
}

export class UploadReading implements Action {
    public readonly type = EDashboardActions.UploadReading;
    constructor(public reading) {}
}

export class SetUploadReading implements Action {
    public readonly type = EDashboardActions.SetUploadReading;
    constructor(public reading: IReading) {}
}

export class GetSimulation implements Action {
    public readonly type = EDashboardActions.GetSimulation;
    constructor(public contract: Contract, public offline = true) {}
}

export class SetSimulation implements Action {
    public readonly type = EDashboardActions.SetSimulation;
    constructor(public payload: any) {}
}

export class GetFunciona implements Action {
    public readonly type = EDashboardActions.GetFunciona;
    constructor(public contract: Contract) {}
}

export class SetFunciona implements Action {
    public readonly type = EDashboardActions.SetFunciona;
    constructor(public payload: any) {}
}

export class FuncionaAPIError implements Action {
    public readonly type = EDashboardActions.FuncionaAPIError;
    constructor(public error: Error) {}
}

export class GetCampaigns implements Action {
    public readonly type = EDashboardActions.GetCampaigns;
    constructor(public partnerNumber: number, public accountNumber: string) { }
}

export class SetCampaigns implements Action {
    public readonly type = EDashboardActions.SetCampaigns;
    constructor(public payload: ICampaign[]) {}
}

export class CampaignsAPIError implements Action {
    public readonly type = EDashboardActions.CampaignsAPIError;
    constructor(public error: Error) {}
}

export class ClearSelectedContractData implements Action {
    public readonly type = EDashboardActions.ClearSelectedContractData;
}

export class GetRecaptcha implements Action {
    public readonly type = EDashboardActions.GetRecaptcha;
    constructor() {}
}

export class SetRecaptcha implements Action {
    public readonly type = EDashboardActions.SetRecaptcha;
    constructor(public recaptcha: boolean) {}
}

export class GetRecaptchaResponse implements Action {
    public readonly type = EDashboardActions.GetRecaptchaResponse;
    constructor() {}
}

export class SetRecaptchaResponse implements Action {
    public readonly type = EDashboardActions.SetRecaptchaResponse;
    constructor(public recaptchaResponse: string) {}
}

export class GetBankList implements Action {
    public readonly type = EDashboardActions.GetBankList;
    constructor() {}
}

export class SetBankList implements Action {
    public readonly type = EDashboardActions.SetBankList;
    constructor(public bankList: IBankList[]) {}
}

export class GetMeterInstructions implements Action {
    public readonly type = EDashboardActions.GetMeterInstructions;
}

export class SetMeterInstructions implements Action {
    public readonly type = EDashboardActions.SetMeterInstructions;
    constructor(public payload: IMeterTypes) {}
}

export class MeterInstructionsAPIError implements Action {
    public readonly type = EDashboardActions.MeterInstructionsAPIError;
    constructor(public error: Error) {}
}

export class GetElectricMobilityWidgetData implements Action {
    public readonly type = EDashboardActions.GetElectricMobilityWidgetData;
    constructor(public contractId: string) {}
}

export class SetElectricMobilityWidgetData implements Action {
    public readonly type = EDashboardActions.SetElectricMobilityWidgetData;
    constructor(public payload: ElectricMobilityWidget) {}
}

export class ElectricMobilityWidgetAPIError implements Action {
    public readonly type = EDashboardActions.ElectricMobilityWidgetAPIError;
    constructor(public error: Error) {}
}

export class ShowNewLocalToastr implements Action {
    public readonly type = EDashboardActions.ShowNewLocalToastr;
    constructor(public payload: boolean) {}
}

export type DashboardActions =
    | GetInvoices
    | SetInvoices
    | InvoicesAPIError
    | GetBalance
    | SetBalance
    | BalanceAPIError
    | GetActiveMeters
    | SetActiveMetersElectricity
    | SetActiveMetersGas
    | GetContractRequests
    | ContractRequestsAPIError
    | SetContractRequests
    | UploadReading
    | SetUploadReading
    | GetSimulation
    | SetSimulation
    | GetFunciona
    | SetFunciona
    | FuncionaAPIError
    | GetCampaigns
    | SetCampaigns
    | CampaignsAPIError
    | RequestAPIError
    | ClearSelectedContractData
    | GetRecaptcha
    | SetRecaptcha
    | GetRecaptchaResponse
    | SetRecaptchaResponse
    | GetBankList
    | SetBankList
    | GetMeterInstructions
    | SetMeterInstructions
    | MeterInstructionsAPIError
    | GetElectricMobilityWidgetData
    | SetElectricMobilityWidgetData
    | ElectricMobilityWidgetAPIError
    | ShowNewLocalToastr;
